import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext.tsx';

const Navbar: React.FC = () => {
  const { user, logout } = useAuth();
  const location = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  const isActive = (path: string) => {
    return location.pathname === path ? 'bg-primary-dark' : '';
  };

  return (
    <nav className="bg-primary text-white shadow-md hidden md:block">
      <div className="container-app mx-auto">
        <div className="flex justify-between items-center py-3">
          {/* Logo and Brand */}
          <div className="flex items-center">
            <Link to="/" className="font-bold text-xl tracking-tight">
              Ultra Cleaning
            </Link>
          </div>

          {/* Desktop Navigation */}
          <div className="flex items-center">
            <Link 
              to="/" 
              className={`px-4 py-2 rounded hover:bg-primary-dark mr-2 ${isActive('/')}`}
            >
              Dashboard
            </Link>
            <Link 
              to="/schedule" 
              className={`px-4 py-2 rounded hover:bg-primary-dark mr-2 ${isActive('/schedule')}`}
            >
              Schedule
            </Link>
            <Link 
              to="/checkin" 
              className={`px-4 py-2 rounded hover:bg-primary-dark mr-2 ${isActive('/checkin')}`}
            >
              Check In
            </Link>
            <Link 
              to="/history" 
              className={`px-4 py-2 rounded hover:bg-primary-dark mr-2 ${isActive('/history')}`}
            >
              History
            </Link>
            <div className="relative ml-3">
              <button 
                className="flex items-center" 
                onClick={() => setIsMenuOpen(!isMenuOpen)}
              >
                <img 
                  className="h-8 w-8 rounded-full" 
                  src={user?.avatar || `https://ui-avatars.com/api/?name=${user?.name || 'User'}&background=dd4b39&color=fff`} 
                  alt={user?.name || 'User'} 
                />
                <span className="ml-2">{user?.name}</span>
              </button>
              {isMenuOpen && (
                <div className="absolute right-0 mt-2 w-48 bg-white rounded-md shadow-lg py-1 z-10">
                  <Link 
                    to="/profile" 
                    className="block px-4 py-2 text-gray-800 hover:bg-gray-100"
                    onClick={closeMenu}
                  >
                    Profile
                  </Link>
                  <button 
                    onClick={() => {
                      logout();
                      closeMenu();
                    }} 
                    className="block w-full text-left px-4 py-2 text-gray-800 hover:bg-gray-100"
                  >
                    Logout
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar; 